import { render, staticRenderFns } from "./Despachos.vue?vue&type=template&id=744d9c96&scoped=true"
import script from "./Despachos.vue?vue&type=script&lang=js"
export * from "./Despachos.vue?vue&type=script&lang=js"
import style0 from "./Despachos.vue?vue&type=style&index=0&id=744d9c96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744d9c96",
  null
  
)

export default component.exports